import { HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from '@sondermind/configuration';

@Injectable({
  providedIn: 'root'
})
export class UrlTargetService {
  constructor(
    private configurationService: ConfigurationService
  ) {}

  targetsSonderMindApis(req: HttpRequest<any>): boolean {
    const { url } = req;
    const configEnv = this.configurationService.env;

    // these urls are all non-nullable, so they can be evaluated without that care
    if (url.startsWith(configEnv.apiBase)
      || url.startsWith(configEnv.svcBase)
      || url.startsWith(configEnv.authBase)
      || url.startsWith(configEnv.chatSvcBase)
      || url.startsWith(configEnv.notificationSvcBase)
      || url.startsWith(configEnv.proxyCommunicationSvcBase)
      || url.startsWith(configEnv.providerMetricsSvcBase)
      || url.startsWith(configEnv.miniformApiBase)
      || url.startsWith(configEnv.clinicalAssessmentsSvcBase)
      || url.startsWith(configEnv.dataExchangeSvcBase)
    ) {
      return true;
    }

    // these values are nullable, so they must be evaluated more carefully
    const { adminBase } = configEnv;
    if (adminBase && url.startsWith(adminBase)) {
      return true;
    }

    const { conciergeSvcBase } = configEnv;
    if (conciergeSvcBase && url.startsWith(conciergeSvcBase)) {
      return true;
    }

    const { engagementApiBase } = configEnv;
    if (engagementApiBase && url.startsWith(engagementApiBase)) {
      return true;
    }

    return false;
  }
}
